import {differenceInMonths, toDate, parseISO, format, differenceInDays} from 'date-fns'
import {differenceInCalendarMonths} from 'date-fns/differenceInCalendarMonths'
import {isAfter} from 'date-fns/isAfter'
import {isBefore} from 'date-fns/isBefore'
import {isValid} from 'date-fns/isValid'
import {ko} from 'date-fns/locale'
import {parse} from 'date-fns/parse'
import {subYears} from 'date-fns/subYears'

import {isSSR} from '$utils/common'

export const convertToDate = (stringDate: string): Date => toDate(parseISO(stringDate))

export const ServerDate = isSSR()
    ? () => new Date()
    : (() => {
          let baseDateTime = Date.now()
          let diff = 0
          let baseDateTimeChanged = false

          return (initialServerDateTime?: number) => {
              // 서버에서 가져온 시간을 클라이언트에서 할당하면, base 와 diff 재설정
              // 최초 한번만 할당을 허용함
              if (initialServerDateTime && !baseDateTimeChanged) {
                  baseDateTime = initialServerDateTime
                  diff = Date.now() - baseDateTime
                  baseDateTimeChanged = true
              }

              // 서버에서는 initialServerDateTime 없이 호출해도 항상 서버시간이니 이슈 없음
              return new Date(Date.now() - diff)
          }
      })()

export const formatWithLocale = (date: Date, formatStr: string) => format(date, formatStr, {locale: ko})

/**
 * @description
 * 날짜표기(일)
 */
export const getDayAndWeekday = (day: string) => format(new Date(day), 'd일 (EEE)', {locale: ko})

export function isValidMonthQuery(month: string | string[] | undefined) {
    return (
        typeof month === 'string' &&
        /^[0-9]{4}-[0-9]{2}$/.test(month) &&
        differenceInCalendarMonths(ServerDate(), month) < 12 &&
        differenceInCalendarMonths(ServerDate(), month) >= 0
    )
}

export function isValidStartEndDateQuery(
    startDate: string | string[] | undefined,
    endDate: string | string[] | undefined,
) {
    return (
        typeof startDate === 'string' &&
        isValid(parse(startDate, 'yyyy-MM-dd', ServerDate())) &&
        !isAfter(parse(startDate, 'yyyy-MM-dd', ServerDate()), ServerDate()) &&
        typeof endDate === 'string' &&
        isValid(parse(endDate, 'yyyy-MM-dd', ServerDate())) &&
        !isBefore(parse(endDate, 'yyyy-MM-dd', ServerDate()), subYears(ServerDate(), 1))
    )
}

function getDate(date: string | Date) {
    return typeof date === 'string' ? convertToDate(date) : date
}

export function getDateDuration(start: string | Date, end: string | Date, dateFormat: string = 'yyyy.MM.dd.') {
    const convertStart = getDate(start)
    const convertEnd = getDate(end)

    const startDate = format(convertStart, dateFormat)
    const endDate = format(convertEnd, dateFormat)
    return `${startDate} ~ ${endDate}`
}

export function getDateDurationYear(start: string | Date, end: string | Date) {
    const convertStart = getDate(start)
    const convertEnd = getDate(end)

    const diffMonths = differenceInMonths(convertEnd, convertStart)
    const year = Math.floor(diffMonths / 12)
    const month = diffMonths % 12

    if (diffMonths === 0) {
        const days = differenceInDays(convertEnd, convertStart)
        return `${days}일`
    }

    return `${year === 0 ? '' : `${year}년`}${month === 0 ? '' : ` ${month}개월`}`
}
